module.exports = __webpack_public_path__ + "static/media/news_events_offers.4710e40f.svg";